/**
 * Created by Ganesh.Sharma on 02-01-2017.
 */
define([], ()=> {
    return ['JsonRPCService', (JsonRPCService)=> {
        return {
            getExistingInstruments: (callGroups)=> {
            return JsonRPCService.send('custompayment', 'custompayment', 'getExistingPaymentInstrumentsForAccount', [], callGroups);
            },
            createPaymentInstrumentForAccount: (instrumentDTO, callGroups)=> {
                return JsonRPCService.send('custompayment', 'custompayment', 'createPaymentInstrumentForAccount', [instrumentDTO], callGroups);
            }
    };
}];
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/services/CustomPaymentService.js
 **/